import React from 'react';
import { RegistrationUi } from './ui';
import { withLoadingAndNoConnectionHandler } from '../integration-wrapper';

export const Registration: React.FC = () => {
    const RegistrationWithHandlers = withLoadingAndNoConnectionHandler(RegistrationUi);

    return <RegistrationWithHandlers isLoading={false} hasError={!!false} />;
};
